import { Swiper, Navigation, Thumbs, EffectFade, Autoplay, Lazy, Pagination, Scrollbar, Mousewheel} from "swiper/swiper.esm";
Swiper.use([Navigation, Thumbs, EffectFade, Autoplay, Lazy, Pagination, Scrollbar, Mousewheel]);

// actions-slider
window.actionsSlidersInit = () => {
	let actionsSliders = document.querySelectorAll('.actions-slider');

	actionsSliders.forEach((slider) => {
		var actionsSliderSwiper = new Swiper(slider.querySelector('.actions-slider__list'), {
			spaceBetween: 30,
			slidesPerView: 1,
			slidesPerGroup: 1,
			// loop: true,
			navigation: {
				nextEl: slider.querySelector('.swiper-button-next'),
				prevEl: slider.querySelector('.swiper-button-prev'),
			},
			autoplay: {
				delay: 7000,
			},
		});

		$('.actions-slider__list').mouseenter(function(){
			actionsSliderSwiper.autoplay.stop();
		});
	
		$('.actions-slider__list').mouseout(function(){
			actionsSliderSwiper.autoplay.start();
		});

		if(slider.querySelectorAll('.actions-slider__item').length <=1){
			slider.querySelector('.swiper-button-prev').remove();
			slider.querySelector('.swiper-button-next').remove();
		}
		
	});

}

// products-slider
window.productsSlidersInit = () => {
	let productsSliders = document.querySelectorAll('.products-slider');

	productsSliders.forEach((slider) => {
		var productsSliderSwiper = new Swiper(slider, {
			spaceBetween: 20,
			slidesPerView: 1,
			slidesPerGroup: 1,
			// loop: true,
			navigation: {
				nextEl: slider.previousElementSibling.querySelector('.swiper-button-next'),
				prevEl: slider.previousElementSibling.querySelector('.swiper-button-prev'),
			},
			autoplay: {
				delay: 5000,
			},
			breakpoints: {
				1160: {
					spaceBetween: 30,
					slidesPerView: 4,
					slidesPerGroup: 1,
				},
				720: {
					spaceBetween: 30,
					slidesPerView: 3,
					slidesPerGroup: 1,
				},
				360: {
					spaceBetween: 20,
					slidesPerView: 2,
					slidesPerGroup: 1,
				},
			}
		});

		$('.products-slider__list').mouseenter(function(){
			productsSliderSwiper.autoplay.stop();
		});
	
		$('.products-slider__list').mouseout(function(){
			productsSliderSwiper.autoplay.start();
		});

		if($(window).width() >= 1160) {
			if(slider.querySelectorAll('.products-slider__item').length <=4){
				slider.closest('.products-slider-block').querySelector('.swiper-buttons').remove();
			}
	
		} else if($(window).width() >=720) {
			if(slider.querySelectorAll('.products-slider__item').length <=3){
				slider.closest('.products-slider-block').querySelector('.swiper-buttons').remove();
			}
		} else if($(window).width() >=360) {
			if(slider.querySelectorAll('.products-slider__item').length <=2){
				slider.closest('.products-slider-block').querySelector('.swiper-buttons').remove();
			}
		} else if($(window).width() < 360) {
			if(slider.querySelectorAll('.products-slider__item').length <=1){
				slider.closest('.products-slider-block').querySelector('.swiper-buttons').remove();
			}
		}

	});
}

// product-card__slider
window.productCardSlidersInit = () => {
	let totalImg = $('.product-card__slider .swiper-slide').length;

	if(totalImg <= 1) {
		$('.product-card__slider .swiper-buttons').remove();
	}

	if(totalImg > 1) {
		const productCardSlider = document.querySelector('.product-card__slider');

		new Swiper(productCardSlider, {
			spaceBetween: 30,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
			},
		});
	}

}